import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { SplitText } from 'gsap/dist/SplitText'
import { gsap } from 'gsap'

gsap.registerPlugin(SplitText)

const useSplitText = (ref, opts, deps = []) => {
  const splitTextInstance = useRef()

  useIsomorphicLayoutEffect(() => {
    splitTextInstance.current = new SplitText(ref.current, opts)
  }, [])

  useIsomorphicLayoutEffect(() => {
    splitTextInstance.current.split()
    
return () => {
      splitTextInstance.current.revert()
    }
  }, deps)

  return splitTextInstance
}

export default useSplitText
